import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const PresentationIcon: LucideIcon = forwardRef(({ size = 24, color = 'currentColor', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M19.3878 0H0.612245C0.274122 0 0 0.274122 0 0.612245V13.8776C0 14.2157 0.274122 14.4898 0.612245 14.4898H9.38776V15.8689L6.4811 18.7755H4.08159C3.74347 18.7755 3.46935 19.0496 3.46935 19.3878C3.46935 19.7259 3.74347 20 4.08159 20H15.9184C16.2565 20 16.5306 19.7259 16.5306 19.3878C16.5306 19.0496 16.2565 18.7755 15.9184 18.7755H13.5189L10.6122 15.8689V14.4898H19.3878C19.7259 14.4898 20 14.2157 20 13.8776V0.612245C20 0.274122 19.7259 0 19.3878 0ZM11.7872 18.7755H8.21278L10 16.9883L11.7872 18.7755ZM18.7755 13.2653H10H1.22449V1.22449H18.7755V13.2653ZM10 11.1248C10.9939 11.1248 11.9882 10.7464 12.7449 9.98976C13.3299 9.40473 13.7045 8.6631 13.8306 7.85718H14.034C14.3722 7.85718 14.6463 7.58306 14.6463 7.24494C14.6463 5.99947 14.1642 4.83151 13.2889 3.95612C12.4135 3.08078 11.2455 2.59873 10 2.59873C9.66188 2.59873 9.38776 2.87286 9.38776 3.21098V3.41441C8.58176 3.54045 7.84012 3.91506 7.25518 4.50008C5.74167 6.01359 5.74167 8.4762 7.25518 9.98971C8.012 10.7465 9.00584 11.1248 10 11.1248ZM10.6122 3.87686C11.2965 3.99841 11.9245 4.32347 12.423 4.82192C12.9214 5.32037 13.2465 5.94849 13.3681 6.63265H10.6122V3.87686ZM8.12102 5.36592C8.47384 5.01306 8.91053 4.77224 9.38776 4.66127V7.24494C9.38776 7.58306 9.66188 7.85718 10 7.85718H12.5836C12.4727 8.33433 12.2318 8.77106 11.879 9.12388C10.8429 10.1599 9.15706 10.1599 8.12102 9.12388C7.08498 8.0878 7.08498 6.402 8.12102 5.36592Z'
        fill={color}
      />
    </svg>
  )
})

PresentationIcon.displayName = 'PresentationIcon'
